/** One edit in a list: what changed on which record, by whom, and where it stands. */
import { Link } from 'react-router'
import { MessageSquare, ThumbsDown, ThumbsUp } from 'lucide-react'
import { Avatar, StatusBadge, Time } from './Bits'
import { fieldLabel, TYPE_LABELS } from '../lib/format'
import type { EditListItem } from '../lib/types'

const ACTION_TEXT = { create: 'Added', update: 'Edited', delete: 'Deleted', merge: 'Merged' } as const

export function EditRow({ edit, compact = false }: { edit: EditListItem; compact?: boolean }) {
  const fields =
    edit.fields.slice(0, 4).map(fieldLabel).join(', ') + (edit.fields.length > 4 ? ` +${edit.fields.length - 4}` : '')
  return (
    <Link to={`/edits/${edit.id}`} className="edit-row">
      <span className="edit-row-main">
        <span className="edit-row-title">
          <span className={`action action-${edit.action}`}>{ACTION_TEXT[edit.action as keyof typeof ACTION_TEXT]}</span>{' '}
          <span className="edit-row-type">{TYPE_LABELS[edit.entity_type].one.toLowerCase()}</span>{' '}
          <strong>{edit.title}</strong>
        </span>
        {!compact && edit.action === 'update' && fields && <span className="edit-row-fields">{fields}</span>}
        {!compact && edit.note && <span className="edit-row-note">“{edit.note}”</span>}
      </span>
      <span className="edit-row-meta">
        <Avatar name={edit.author.name} src={edit.author.avatar_url} size={20} />
        <span className="edit-row-author">{edit.author.name}</span>
        <Time ms={edit.created_at} />
        {!compact && (
          <>
            {edit.votes.yes > 0 && (
              <span className="edit-row-stat" aria-label={`${edit.votes.yes} approve`}>
                <ThumbsUp size={14} aria-hidden="true" /> {edit.votes.yes}
              </span>
            )}
            {edit.votes.no > 0 && (
              <span className="edit-row-stat" aria-label={`${edit.votes.no} reject`}>
                <ThumbsDown size={14} aria-hidden="true" /> {edit.votes.no}
              </span>
            )}
            {edit.comment_count > 0 && (
              <span className="edit-row-stat" aria-label={`${edit.comment_count} comments`}>
                <MessageSquare size={14} aria-hidden="true" /> {edit.comment_count}
              </span>
            )}
            <StatusBadge status={edit.status} auto={edit.auto_applied} />
          </>
        )}
      </span>
    </Link>
  )
}
